const test = function(component){
    var self = this;

    this.random = function(){
        var config = component.question.config;
        var random_insert = {}


        for(let g=0; g<config.groups.length; g++){
            var group = config.groups[g];
            

            switch(config.type){
                default:
                    var random_input = group.inputs[getRandomInt(0,group.inputs.length)];
                    random_insert[group.id] = random_input.value;
                break;

                case"TextArea":
                    random_insert[group.id] = {};
                    for(let i=0; i<group.inputs.length; i++){
                        var input = group.inputs[i];
                        var insert_value = "Špéçïâl Čháräčétęr Tëśt #`'\"/~"
                        random_insert[group.id][input.id] = insert_value
                    }
                break;
    
                case"Checkbox":
                    var loop = getRandomInt(1,group.inputs.length);
                    random_insert[group.id] = [];
                    for(let i=0; i<loop; i++){
                        var random_input = group.inputs[getRandomInt(0,group.inputs.length)];
                        random_insert[group.id].push(random_input.value)
                    }
                break;
                
                case"DatePicker":
                    random_insert[group.id] = {};
                    for(let i=0; i<group.inputs.length; i++){
                        var input = group.inputs[i];
                        var random = new Date();
                        random.setDate(getRandomInt(1,29));
                        var year = random.getFullYear()
                        var month = random.getMonth()+1; month = month<10 ? '0'+month : month;
                        var date = random.getDate(); date = date<10 ? '0'+date : date;
                        random_insert[group.id][input.id] = year+'-'+month+'-'+date;
                    }
                break;
                
                case"Number":
                    random_insert[group.id] = {};
                    for(let i=0; i<group.inputs.length; i++){
                        var input = group.inputs[i];
                        var insert_value = getRandomInt(1,101);
                        random_insert[group.id][input.id] = insert_value
                    }
                break;
                
                case"SelectTable":
                    random_insert[group.id] = {};
                    var columns = group.type_config[config.type].items;
                    var options = group.inputs;

                    for(let c=0; c<columns.length; c++){
                        var column = columns[c];
                        var random_input = options[getRandomInt(0,options.length)];
                        
                        random_insert[group.id][column.id] = random_input.value;
                    }
                break;

                case"Percentage":
                    random_insert[group.id] = {};
                    for(let i=0; i<group.inputs.length; i++){
                        var tally = component.controller.tally();
                        var input = group.inputs[i];
                        var tally_value = tally[input.id] ? tally[input.id] : 0;
                        var max = 100-tally_value;
                        var insert_value = getRandomInt(1,max);
                        random_insert[group.id][input.id] = insert_value.toString();
                    }
                    random_insert = JSON.stringify(random_insert);
                    random_insert = JSON.parse(random_insert);
                    component.value = random_insert;
                break;

                case"Ranking":
                    function move(max, group_id){
                        var source = component.ranking.source[group_id];
                        var ranked = component.ranking.ranked[group_id];

                        for(let i=0; i<source.length; i++){
                            var takeIt = getRandomInt(0,2);
                            if(takeIt==1 && ranked.length<max && source[i].other===false){
                                ranked.push(source[i]);
                                source.splice(i, 1);
                            }
                        }

                        if(ranked.length<max){
                            move(max, group_id);
                        }
                    }

                    var max = group.type_config[config.type].max;
                    move(max, group.id);
                break;
            }
            
            component.value = random_insert;
        }

        setTimeout(function(){
            component.controller.value_action().then(function(){
                component.validate();
                component.emitValue('random');
            })    
        },800)
        
    }

    this.validate = function(){
        return component.validate(true);
    }

    function getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min)) + min; //The maximum is exclusive and the minimum is inclusive
    }  
}

export default function(name,controller){
    return{
        name: name,
        props: {
            question: {
                type: Object,
                required: true
            },
            survey: {
                type: Object,
                required: true
            }
        },
        created: function(){
            this.controller = new controller(this);
            this.controller.test = new test(this);
        },
        mounted: function(){
            this.init();
        },
        data: function(){
            return {
                controller: null,
                value: {},
                enableOther: null,
                other: null,
                disabled: null,
                emitTimer: null,
                ranking: null,
                percentage: null,
                input_timer: null,
                valid: null,
                valid_form: null
            }
        },
        methods: {
            init: function(){            
                var self = this;
                var type = self.question.config.type;
                var groups = self.question.config.groups;
                var valid = {
                    default: self.question.config.required===false,
                    advanced: true
                }
                self.valid = valid;

                self.$emit('initQuestion',{
                    controller: self.controller,
                    question: self.question,
                    configMap: self.get_configMap(),
                    valid: self.valid
                });
                self.emitValue('initalizing emit to set value container')
            },
            emitValue: function(source){
                var self = this;
                self.$emit('setValue',{
                    value: self.value,
                    other: self.other,
                    question: self.question,
                    valid: self.valid
                });
            },
            get_config: function(group_id, input_value){
                var group = null;

                if(group_id){
                    var groups = this.question.config.groups;
                    for(let g=0; g<groups.length; g++){
                        group = groups[g];
                        if(group.id == group_id){break;}
                    }
                }

                var input = null;
                if(input_value){
                    var inputs = group.inputs;
                    for(let i=0; i<inputs.length; i++){
                        input = inputs[i];
                        if(input.value == input_value){break;}
                    }
                }

                return {
                    group: group,
                    input: input
                };
            },
            get_configMap: function(){
                var output = {};

                var groups = this.question.config.groups;
                for(let g=0; g<groups.length; g++){
                    var group = groups[g];
                    output[group.id] = {
                        group: group,
                        inputs: {}
                    };

                    for(let i=0; i<group.inputs.length; i++){
                        var input = group.inputs[i];
                        output[group.id].inputs[input.id] = input;
                    }
                }

                return output;
            },
            validate: function(debug=false){
                this.$refs.form.validate();
                var customValidate = (this.controller.validate && typeof this.controller.validate=='function');
                var result = this.is_valid(debug);
                this.valid.default = result;
                
                return result;
            },
            is_valid: function(debug=false){
                let component = this;
                var is_required = this.question.config.required;
                let question_type = this.question.config.type;
                let models = {
                    single_input: ['Radio','RadioTable','Select'],
                    answer_array: ['Checkbox', 'CheckboxConstrained'],
                    custom: ['Ranking','Percentage','SelectTable','Rating'],
                    grouped_inputs: ['Number','TextArea','DatePicker']
                }
                let validation_model = null;
                for(let t in models){
                    let model_type = models[t];
                    if(this.in_array(question_type, model_type)){
                        validation_model = t;
                        break;
                    }
                }

                
                var valid = (is_required===false);

                if(is_required && this.value){
                    if(validation_model===null){
                        console.error('unknown validation model for: '+question_type)
                    }else{
                        switch(validation_model){
                            default:
                                valid = eval(validation_model+'('+debug+')');
                            break;

                            case"custom":
                                if((this.controller.validate && typeof this.controller.validate=='function')){
                                    valid = component.controller.validate(debug)
                                }else{
                                    console.error('missing controller validation for: '+question_type)
                                }
                            break;
                        }
                    }
                }

                if(debug){
                    console.log({
                        question_type: question_type,
                        validation_model: validation_model,
                        valid: valid,
                        answers: component.question.value
                    })
                }
                
                return valid;

                function single_input(debug){
                    let valid = false;
                    let groups = component.question.config.groups;
                    for(let g=0; g<groups.length; g++){
                        let group = groups[g];
                        let group_id = group.id;

                        var answer = component.value[group_id];

                        if(answer!=null && typeof answer!='undefined'){
                            //Validate 'other'
                            if(typeof answer=='number' || typeof answer=='string'){
                                var other = component.other[group_id][answer];
                                var enableOther = component.enableOther[group_id][answer];
                                valid = enableOther===false || (other!=null && other.length>0);
                                if(!valid){
                                    break;
                                }
                            }else{
                                for(let input_id in answer){
                                    var answer_value = answer[input_id];
                                    valid = !(answer_value===null || answer_value.length==0);
                                    if(!valid){
                                        break;
                                    }
                                }
                            }
                        }else{
                            valid = false;
                            break;
                        }                                              
                    }

                    return valid;
                }

                function answer_array(debug=false){
                    var valid = false;
                    var enableOther = component.enableOther;
            
                    let groups = component.question.config.groups;
                    for(let g=0; g<groups.length; g++){
                        let group = groups[g];
                        let group_id = group.id;
                        if(debug){
                            console.log({
                                group: group,
                                group_id: group_id,
                                component_question: component.question
                            })
                        }
                        let answers = component.value[group_id];
                        // For CheckboxConstrained
                        let hasCheckboxConstrainedConfig =
                          component.question.config.max_num_picks !== undefined &&
                          component.question.config.min_num_picks !== undefined &&
                          component.question.config.max_num_picks !== null &&
                          component.question.config.min_num_picks !== null;
                        if (hasCheckboxConstrainedConfig){
                            let max_num_picks =
                              component.question.config.max_num_picks !== 0
                                ? component.question.config.max_num_picks
                                : group.inputs.length;
                            valid =
                              component.question.config.min_num_picks <= answers.length &&
                              answers.length <= max_num_picks;
                            if (!valid || answers.length < max_num_picks){
                                // Reset
                                component.controller.resetDisabled(group_id);
                                break;
                            }
                            
                            if (answers.length==max_num_picks){ // Disable Others (Non-Selected)
                                component.controller.setDisableNonSelected(group_id);
                            }
                            else if (answers.length<max_num_picks){ // Enable if there are disabled options
                                component.controller.resetDisabled(group_id);
                            }
                            else {
                                if(debug){
                                    console.log("Non-Feasible Case");
                                }
                                break;
                            }
                        }
                        valid = answers.length>0;
                        if(valid){
                            for(let i=0; i<answers.length; i++){
                                var value = answers[i];
                                var other = component.other[group_id][value] ? component.other[group_id][value].trim() : component.other[group_id][value];
                                var enabled = enableOther[group_id][value];
                                valid = enabled===false || other!=null && other.length>0;
                                if(valid===false){
                                    break;
                                }
                            }
                        }
                        if(valid===false){
                            break;
                        }
                        
                    }
                        
                    if(debug){
                        console.log('checkbox validate',{
                            valid: valid,
                            answers: component.value,
                            others: component.other
                        })
                    }
                    
                    return valid;
                }
               
                function grouped_inputs(debug){
                    var valid = false;                    
                    var values = component.value;
                    var enableOther = component.enableOther;
                    var other = component.other;
                    let question_type = component.question.config.type;
            
                    let groups = component.question.config.groups;
                    for(let g=0; g<groups.length; g++){
                        let group = groups[g];
                        let group_id = group.id;
                        let grouped_answers = component.value[group_id];

                        for(let input_id in grouped_answers){
                            var value = grouped_answers[input_id];
                            if (question_type==='TextArea'){
                                valid = value!=null && value.trim().length>0
                            }
                            else {
                                valid = value!=null && (enableOther[group_id][input_id]===false || other[group_id][input_id].length>0);
                            }
            
                            if(!valid){
                                break;
                            }
                        }

                        if(!valid){
                            break;
                        }

                    }
            
                    return valid;
                }
                
                
            }
        },
        computed: {
            display: function(){
                return this.question.display;
            },
            header: function(){
                return this.question.config.header[this.$language()] ? this.question.config.header[this.$language()] : this.survey.mode=='debug' ? '[HEADER]' : '';
            },
            body: function(){
                return this.question.config.body[this.$language()] ? this.question.config.body[this.$language()] : this.survey.mode=='debug' ? '[BODY]' : '';
            },
            subtext: function(){
                return this.question.config.subtext[this.$language()] ? this.question.config.subtext[this.$language()] : this.survey.mode=='debug' ? '[SUBTEXT]' : '';
            },
            footer: function(){
                return this.question.config.footer[this.$language()] ? this.question.config.footer[this.$language()] : this.survey.mode=='debug' ? '[FOOTER]' : '';
            },
        },
        watch: {
            value: {
                deep: true,
                handler: function(){
                    if(this.survey.initQuestion_done){
                        var self = this;
                        self.controller.value_action().then(function(){
                            self.validate();
                            self.emitValue('watch: value');
                        })                      
                    }
                }
            },
            other: {
                deep: true,
                handler: function(){
                    if(this.survey.initQuestion_done){
                        var self = this;
                        clearTimeout(self.input_timer);
                        self.input_timer = setTimeout(function(){
                            self.controller.value_action().then(function(){
                                self.validate();
                                self.emitValue('watch: other');
                            })
                        },1000)                        
                    }
                }
            },

            display: function(){
                if(this.display===false){
                    this.controller.clear();               
                }

                //Necessary to trigger logics - if something else is dependent on display
                this.emitValue('display > '+this.question.config.id+' : '+this.display);
            }
        }        
    }
}